import React from 'react';
import { MfePropsType } from 'src/types/mfeProps';
import RegularLayout from 'src/layouts/RegularLayout';
import Root from '../root.loader';
import { RegularLayoutPropsType } from 'src/layouts/RegularLayout/types';

type RegularLayoutMfePropsType = MfePropsType & RegularLayoutPropsType;

export default function RegularLayoutMfe(props: RegularLayoutMfePropsType) {
  return (
    <Root
      id="RegularLayout"
      {...props}
    >
      <RegularLayout
        {...props}
        properties={props?.properties}
      />
    </Root>
  );
}
